const walletData = [
    {
      image: 'assets/images/nft/wallet/metamask.png',
      title: 'Metamask',
      content: 'MetaMask is a software cryptocurrency wallet used to interact with the Ethereum blockchain.',
      btn_color: "btn-soft-info"
    },
    {
      image: 'assets/images/nft/wallet/coinbase.png',
      title: 'Coinbase Wallet',
      content: 'Coinbase Wallet is a software product that gives you access to a wide spectrum.',
      btn_color: "btn-info"
    },
    {
      image: 'assets/images/nft/wallet/binance.png',
      title: 'Binance',
      content: 'Binance offers a relatively secure, versatile way to invest in and trade cryptocurrencies.',
      btn_color: "btn-soft-info"
    },
  ];
  
  export { walletData };
  